import styled from 'styled-components';

const PaperContainer = styled.div`
  border-radius: 5px;
  background-color: ${(props) => props.theme.colors.surface};
  padding: 10px;
  margin: 5px;
  box-shadow: 3px 3px 3px darkgray;
`;

export {
  PaperContainer,
}